"use client";

import { useEffect, useState } from "react";

import { strings } from "@perceptron/constants";
import { Icon } from "@perceptron/ui/components/icon";
import { Switch } from "@perceptron/ui/components/switch";
import { Tooltip, TooltipContent, TooltipTrigger } from "@perceptron/ui/components/tooltip";

import { useDevModeStore, useIsDevModeAvailable, useIsDevModeActive } from "@demo/store/dev-mode";

export const DevModeToggle = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const isAvailable = useIsDevModeAvailable();
  const isActive = useIsDevModeActive();
  const setActive = useDevModeStore((s) => s.setActive);

  if (!mounted || !isAvailable) return null;

  const copy = strings.report.devMode;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="hidden sm:inline-flex">
          <Switch
            aria-label={isActive ? copy.disableAriaLabel : copy.enableAriaLabel}
            checked={isActive}
            // The shared off-track is a black tint, which reads as recess on
            // the raised panels every other switch sits on. Here it lands on
            // the page itself, where darker than the background is invisible.
            className="h-6 w-10 dark:data-[state=unchecked]:bg-muted"
            data-testid="dev-mode-toggle"
            thumbClassName="size-5 text-foreground dark:data-[state=unchecked]:text-background"
            onCheckedChange={setActive}
          >
            <Icon className="size-3" name="code-xml" />
          </Switch>
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <p>{isActive ? copy.enabledTooltip : copy.disabledTooltip}</p>
      </TooltipContent>
    </Tooltip>
  );
};
